import { endOfMonth, format, startOfMonth } from "date-fns";

export const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function getTodayKey(date = new Date()) {
  return format(date, "yyyy-MM-dd");
}

export function getDayName(date = new Date()) {
  return DAYS[date.getDay()];
}

export function getNowTimeValue(date = new Date()) {
  return format(date, "HH:mm");
}

export function getMonthRange(year, monthNumber) {
  const date = new Date(Number(year), Number(monthNumber) - 1, 1);
  return {
    from: format(startOfMonth(date), "yyyy-MM-dd"),
    to: format(endOfMonth(date), "yyyy-MM-dd")
  };
}

export function displayDate(dateKey) {
  if (!dateKey) return "-";
  return format(new Date(`${dateKey}T00:00:00`), "dd MMM yyyy");
}

export function sortByDateDesc(a, b) {
  return String(b.date || "").localeCompare(String(a.date || ""));
}
